const state = {
    Items: {
        data: [],
        total: 0,
        pages: {
            page: 1,
            totalPage: 1,
            limit: 25,
            filter: {}
        },
    },
    Loadings: {
        list: false,
        detail: false,
    },
    Item: {
        id: null,
        contract: null,
        properties: null,
        recorded_by: { 
            email: null, 
            name: null, 
            phone: null 
        },
        reported_date: null,
        reported_time: null,
        recorded_date: null,
        recorded_date_time: null,
        recorded_time: null,
        location: null,
        service_categories: null,
        equipment: [],
        feedback_detail: null,
        sla: null,
        user: null,
        work_order_id: null,
        expiry_date: null,
        other_locations: null,
        deliverables: null,
        expiry_date: null,
        work_finding: null,
        action_taken: null,
        status: 'New'
    },
};

const getters = {
    Items: (state) => state.Items,
    Loadings: (state) => state.Loadings,
    Item: (state) => state.Item,
};

const actions = {
    async getList({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });
        return new Promise((resolve, reject) => {
            global.axios.get(`api/case-hot-button`, { params: params })
                .then(response => {
                    commit('setLoadings', { key: "list", val: false });
                    response.data.data.pages = params
                    commit('setListItems', response.data.data);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async deteleItem({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/case-hot-button`, {
                    data: {
                        ids: params
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async getSimilarCase({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });
        return new Promise((resolve, reject) => {
            global.axios.get(`api/case-hot-button`, { params: params })
                .then(response => {
                    commit('setLoadings', { key: "list", val: false });
                    response.data.data.pages = params
                    commit('setSimilarCase', response.data.data);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async getCase({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/case-hot-button/${params.case_id}`)
                .then(response => {
                    response.data.data.pages = params
                    commit('setItem', response.data.data);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },

    async raiseCase({ commit }, params) {
        if (params.id) {
            return new Promise((resolve, reject) => {
                global.axios.put(`api/case-hot-button/${params.id}`, params)
                    .then(response => {
                        response.data.data.pages = params
                        commit('setTotalListItems', 0);
                        resolve(response);
                    })
                    .catch(error => reject(error));
            });
        } else {
            return new Promise((resolve, reject) => {
                global.axios.post(`api/case-hot-button`, params)
                    .then(response => {
                        response.data.data.pages = params
                        commit('setTotalListItems', 0);
                        resolve(response);
                    })
                    .catch(error => reject(error));
            });
        }
    },

    async exportCsv({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/case-hot-button/export`, {
                    params: params,
                    responseType: 'blob'
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },

    async updateRemarksCase({ commit }, params) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            for (var i = 0; i < params.action.photos.length; i++) {
                let photo = params.action.photos[i];
                formData.append('photos[' + i + ']', photo);
            }
            if (params.data.description == null)
                params.data.description = '';
            formData.append('description', params.data.description);
            formData.append('remark_type', params.data.remark_type);
            global.axios(`/api/case-hot-button/remarks/${params.case_id}`, {
                    method: "POST",
                    data: formData,
                    headers: {
                        Accept: "application/json",
                    },
                })
                .then(response => {
                    let data = {};
                    if (params.data.remark_type == 'CaseActionTaken') {
                        data.job_action_taken_id = response.data.data.action_taken.id;
                        data.action_taken = response.data.data.action_taken;
                    } else {
                        data.job_work_finding_id = response.data.data.work_finding.id;
                        data.work_finding = response.data.data.work_finding;
                    }
                    commit('updateRemarkCase', data)
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },

    async deleteAttachments({ commit }, params) {
        return new Promise((resolve, reject) => {

            global.axios(`/api/attachments`, {
                    method: "DELETE",
                    data: { ids: params.ids },
                    headers: {
                        Accept: "application/json",
                    },
                })
                .then(response => {
                    commit('deleteAttachments', params);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async getCountCase({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/case-hot-button/count`, { params: params })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async linkCaseSubmit({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/case-hot-button/link-case`, params)
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
};

const mutations = {
    setListItems(state, data) {
        data.pages.totalPage = Math.ceil(data.total / data.pages.limit)
        state.Items.data = data.items
        state.Items.total = data.total
        state.Items.pages = data.pages
    },
    setTotalListItems(state, total) {
        state.Items.total = total
    },
    setSimilarCase(state, data) {
        data.pages.totalPage = Math.ceil(data.total / data.pages.limit)
        state.Items.data = data.items
        state.Items.total = data.total
        state.Items.pages = data.pages
    },
    setLoadings(state, data) {
        state.Loadings[data.key] = data.val;
    },
    setItem(state, data) {
        state.Item = JSON.parse(JSON.stringify(Object.assign(state.Item, data)));
    },
    setItemToCreate(state) {
        state.Item = {
            id: 0,
            contract: null,
            properties: null,
            recorded_by: { 
                email: null, 
                name: null, 
                phone: null 
            },
            reported_date: null,
            reported_time: null,
            recorded_date: null,
            recorded_date_time: null,
            recorded_time: null,
            location: null,
            service_categories: null,
            equipment: [],
            feedback_detail: null,
            sla: null,
            user: null,
            work_order_id: null,
            expiry_date: null,
            other_locations: null,
            deliverables: null,
            expiry_date: null,
            work_finding: null,
            action_taken: null,
            status: 'New'
        };
    },
    updateRemarkCase(state, data) {
        state.Item = {...state.Item, ...data };
    },
    deleteAttachments(state, data) {
        if (data.action == 'action_taken') {
            state.Item.action_taken.attachments = state.Item.action_taken.attachments.filter(img => !data.ids.includes(img.id))
        }
        if (data.action == 'work_finding') {
            state.Item.work_finding.attachments = state.Item.work_finding.attachments.filter(img => !data.ids.includes(img.id))
        } else {
            state.Item.attachments = state.Item.attachments.filter(img => !data.ids.includes(img.id))
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}